// removed by extract-text-webpack-plugin
module.exports = {"Burger":"Burger-module__Burger__1mdm1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/Burger.module.css
// module id = 106
// module chunks = 2